<template>
  <div id="app" dir="rtl" class="min-h-screen bg-beige-50 font-body">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style scoped></style> 